// Ref: https://github.com/vuejs-tips/vue-the-mask/blob/master/src/directive.js
import { getInputElement, event, insertAfter, createMaskElement, generateClassName } from './common'
import Cleave from 'cleave.js'
import Vue from 'vue'

/**
 * Takes in param:
 */
function bind(el, binding, vnode) {
  // In Binding, we will create the dummy mask input element and attach it to the document
  const maskClass = generateClassName()
  const maskInput = createMaskElement(maskClass)
  insertAfter(maskInput, el)
  el.maskClass = maskClass
}

function inserted(el, binding) {
  Vue.nextTick(() => {
    // Cleave cannot initiate on bind as I think the mask element has not registered in the document
    // So we will do it here
    if (el.maskClass) {
      if (binding.value !== undefined && binding.value !== null) {
        // Set params if available here
      }
      try {
        const cleave = new Cleave('.' + el.maskClass, {
          date: true,
          datePattern: ['d', 'm', 'Y'],
          // use lazy show, if not we have to do work around for delimiter deletion
          delimiterLazyShow: true
        })
        el.cleave = cleave

        const maskInputArr = document.getElementsByClassName(el.maskClass)
        if (maskInputArr && maskInputArr.length > 0) {
          // const maskInput = maskInputArr[0]
          const inputEL = getInputElement(el)
          inputEL.oninput = function (evt) {
            if (!evt.isTrusted) return // avoid infinite loop

            // by default, keep cursor at same position as before the mask
            let position = inputEL.selectionEnd
            // save the character just inserted
            let digit = inputEL.value[position - 1]

            cleave.setRawValue(inputEL.value)
            inputEL.value = cleave.properties.result
            inputEL.dispatchEvent(event('input'))

            // if the digit was changed, increment position until find the digit again
            while (position < inputEL.value.length && inputEL.value.charAt(position - 1) !== digit) {
              position++
            }
            if (inputEL === document.activeElement) {
              inputEL.setSelectionRange(position, position)
              setTimeout(function () {
                inputEL.setSelectionRange(position, position)
              }, 0)
            }
          }
          // Mask the initial value also
          if (inputEL.value !== undefined && inputEL.value !== null) {
            cleave.setRawValue(inputEL.value)
            if (inputEL.value !== cleave.properties.result) {
              inputEL.value = cleave.properties.result
              inputEL.dispatchEvent(event('input'))
            }
          }
        } else {
          throw new Error('Cannot find mask input')
        }
      } catch (err) { console.log(err) }
    }
  })
}

function unbind(el, binding) {
  if (el.cleave) {
    try {
      el.cleave.destroy()
    } catch (err) { console.log(err) }
  }
}

export default {
  name: 'dateMask',
  bind,
  inserted,
  unbind
}
